import React from "react";
import { Link } from "react-router-dom";
import innerBanner from '../../public/assets/images/bg/inner-banner.png';

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

function Breadcrumb({ banner, pageName, pageTitle, id, image, myRef }) {
  const executeScroll = () => scrollToRef(myRef)
  return (
    <div
      className="inner-banner"
      // style={{
      //   background: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),url(${image ? image : innerBanner})`,
      //   backgroundSize: "cover",
      //   backgroundRepeat: "no-repeat",
      //   backgroundPosition: "center"
      // }}
    >
      <div className="container">
      <div className="slider-bg-1" image={banner}>
        <h2
                className="inner-banner-title wow fadeInLeft"
                data-wow-duration="1.5s"
                data-wow-delay=".2s"
              >
                {pageTitle}
              </h2>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb gap-3 justify-content-start">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {pageName}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
    </div>
  );
}

export default Breadcrumb;
